// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from '../../../Utility/RichText';
import { StyledCopyBody, StyledDefaultLabel, StyledToolTipContainer, StyledDescription } from './Label.styles';

function Label(props) {
  const { label, description, toolTip, disabled, labelColor } = props;

  return (
    <div>
      {label &&
        (description ? (
          <>
            <StyledCopyBody weight="bold" noMargins>
              <RichText disabled={disabled} content={label} />
              {toolTip && <StyledToolTipContainer>{toolTip}</StyledToolTipContainer>}
            </StyledCopyBody>

            <StyledDescription noMargins>
              <RichText content={description} />
            </StyledDescription>
          </>
        ) : (
          <StyledDefaultLabel>
            <RichText disabled={disabled} content={label} labelColor={labelColor} />
            {toolTip && <StyledToolTipContainer>{toolTip}</StyledToolTipContainer>}
          </StyledDefaultLabel>
        ))}
    </div>
  );
}

Label.propTypes = {
  /** Label copy - displays beside form element */
  label: PropTypes.string,
  /** Description copy - displays below the label */
  description: PropTypes.string,
  /** Takes a ToolTip component and displays it beside the label */
  toolTip: PropTypes.node,
  disabled: PropTypes.bool,
  labelColor: PropTypes.string
};

Label.defaultProps = {
  label: undefined,
  description: undefined,
  toolTip: null,
  disabled: false,
  labelColor: ''
};

export default Label;
